// utils/usersService.js

import utils from "../utils/utils";


export const BOAPI = {
  fetchUsers: () => utils.requestData('BOGetUsers', {}),
  deleteUser: (userId) => utils.requestData('DeleteUser', { userId }),
  fetchPendingUsers: () => utils.requestData('BOGetPendingUsers', {}),
  approveUser: (userId) => utils.requestData('BOApproveUser', { userId }),

  // פעילויות
  fetchAllActivities: (range) => utils.requestData('BOGetAllActivities', range || {}),
  fetchUserActivities: (userId, range) => utils.requestData('BOGetUserActivities', { userId: parseInt(userId, 10), ...(range || {}) }),

  // דשבורד
  fetchTaskStats: () => utils.requestData('BOGetTaskStats', {}),
  sendDailyDigestEmail: (toEmail) => utils.requestData('BOSendDailyDigestEmail', { toEmail }),
  fetchUserFeedback: (done) => utils.requestData('BOGetUserFeedback', { done: done ? '1' : '0' }),
  markFeedbackDone: (id, done = true) => utils.requestData('BOMarkFeedbackDone', { id, done: done ? '1' : '0' }),

  // צדקה
  fetchDonationsSummary: () => utils.requestData('BOGetDonationsSummary', {}),

  // הקדשות
  fetchHakdashotData: () => utils.requestData('BOGetHakdashot', {}),
  updateHakdashotValue: (item) => utils.requestData('BOUpdateHakdashotValue', item),
  addHakdashotValue: (params) => utils.requestData('BOAddHakdashotValue', params),

  // מבחנים
  fetchQuizzes: () => utils.requestData('BOGetQuizzes', {}),
  fetchQuizDetails: (storyId) => utils.requestData('BOGetQuizDetails', { storyId }),
  saveQuiz: (params) => utils.requestData('BOSaveQuiz', params),
  deleteQuiz: (storyId) => utils.requestData('BODeleteQuiz', { storyId }),

  // סטוריז
  fetchStories: () => utils.requestData('BOGetStories', {}),
  addStory: (params) => utils.requestData('BOAddStory', params),
  updateStory: (params) => utils.requestData('BOUpdateStory', params),
  deleteStory: (id) => utils.requestData('BODeleteStory', { id }),
  uploadStoryFile: (base64Data, fileExt) => utils.uploadFile(base64Data, 'stories', fileExt),

  // מצב תחזוקה
  fetchMaintenanceMode: () => utils.requestData('BOGetMaintenanceMode', {}),
  setMaintenanceMode: (enabled) => utils.requestData('BOSetMaintenanceMode', { enabled }),

  // שיעורים בנושא (קישור שיעורי שמע קיימים לימי לימוד קבועים-מחזוריים, כמו תניא)
  fetchDecisions: () => utils.requestData('BOGetDecisions', {}),
  fetchMp3Categories: () => utils.requestData('BOGetMp3Categories', {}),
  searchMp3Files: (q, categoryId) => utils.requestData('BOSearchMp3Files', { q, categoryId }),
  fetchRelatedLessons: () => utils.requestData('BOGetRelatedLessons', {}),
  addRelatedLesson: (params) => utils.requestData('BOAddRelatedLesson', params),
  updateRelatedLesson: (params) => utils.requestData('BOUpdateRelatedLesson', params),
  deleteRelatedLesson: (id) => utils.requestData('BODeleteRelatedLesson', { id }),
  updateMp3File: (params) => utils.requestData('BOUpdateMp3File', params),

  // ימים מיוחדים (תאריך עברי חוזר-שנתי + אודות/ביוגרפיה/שיעורים)
  fetchSpecialDays: () => utils.requestData('BOGetSpecialDays', {}),
  addSpecialDay: (params) => utils.requestData('BOAddSpecialDay', params),
  updateSpecialDay: (params) => utils.requestData('BOUpdateSpecialDay', params),
  deleteSpecialDay: (id) => utils.requestData('BODeleteSpecialDay', { id }),
  fetchSpecialDayLessons: (specialDayId) => utils.requestData('BOGetSpecialDayLessons', { specialDayId }),
  addSpecialDayLesson: (params) => utils.requestData('BOAddSpecialDayLesson', params),
  addSpecialDayLessonFromLink: (params) => utils.requestData('BOAddSpecialDayLessonFromLink', params),
  deleteSpecialDayLesson: (id) => utils.requestData('BODeleteSpecialDayLesson', { id }),

  // נוטיפיקציות פוש
  sendNotification: (params) => utils.requestData('BOSendNotification', params),
  fetchNotificationHistory: () => utils.requestData('BOGetNotificationHistory', {}),
};

class UsersService {
  users = null;

  async getUsers(fetcher) {
    if (this.users) return this.users;
    const data = await fetcher();
    this.users = data;
    return data;
  }

  removeUser(userId) {
    this.users = this.users?.filter(u => u.id !== userId);
  }

  clear() {
    this.users = null;
  }
}

export default new UsersService();
